import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation, Link } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { apiCall, mediaUrl } from "./util";
import axios from "axios";
import Modal from "react-modal";
import {
  tagline,
  emergencyContact,
  gokulam_logo_icon,
  emergencyBg,
  emergency24x7,
  mailIcon,
  gokulam_superspeciality_logo,
} from "./Image";
import { useSpring, animated } from "react-spring";
import { useData } from "../context/DataContext";
import { setTopSpaceHeight } from "./custom";

const Header = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navbarCloneRef = useRef(null);
  const [isMenuVisible, setMenuVisible] = useState(false);
  const location = useLocation();
  const [data, setData] = useState([]);
  const [department, setDepartment] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  // const [isDropdownSubmenuOpen, setIsDropdownSubmenuOpen] = useState(false);
  const toggledropdown = () => setIsOpen(!isOpen);
  const settingdata = useData();
  const [marginTop, setMarginTop] = useState(window.scrollY > 50 ? 0 : 14);
  const [hasScrolled, setHasScrolled] = useState(window.scrollY > 50);
  const [showImage, setShowImage] = useState(false);
  const [menuDirection, setMenuDirection] = useState("down"); // Track menu direction

  // Animation for the menu
  const props = useSpring({
    transform:
      menuDirection === "down"
        ? isMenuVisible
          ? "translateY(0%)"
          : "translateY(-90%)" // Swipe down
        : isMenuVisible
        ? "translateY(0%)"
        : "translateY(100%)", // Swipe up
    opacity: isMenuVisible ? 1 : 0,
    config: { tension: 400, friction: 30 },
  });

  const handleMenuToggle = (direction) => {
    setMenuDirection(direction);
    const body = document.body;
    const html = document.documentElement;

    if (isMenuVisible) {
      body.classList.remove("navbar-collapse-show");
      html.classList.remove("overflow-hidden");
    } else {
      body.classList.add("navbar-collapse-show");
      html.classList.add("overflow-hidden");
    }

    setMenuVisible(!isMenuVisible);
  };

  const handleMenuCloneToggle = (direction) => {
    setMenuDirection(direction);
    // console.log(direction)
    const body = document.body;
    const html = document.documentElement;

    if (isMenuVisible) {
      body.classList.remove("navbar-collapse-show");
      html.classList.remove("overflow-hidden");
    } else {
      body.classList.add("navbar-collapse-show");
      html.classList.add("overflow-hidden");
    }

    setTimeout(() => {
      setMenuVisible(!isMenuVisible);
    }, 1000); // 1000ms = 1 second
    setMenuDirection("down");
  };

  const [openDropdown, setOpenDropdown] = useState(null);

  const isDepartmentActive =
    location.pathname.startsWith("/department") ||
    location.pathname.startsWith("/doctorprofile");

  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const response = await axios.get(apiCall + "department/getall");
        setDepartment(response.data);
        // console.log(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchDepartment();
  }, []);

  useEffect(() => {
    setOpenDropdown(null);
  }, [location.pathname]);

  // const toggleDropdown = () => {
  //   setIsDropdownOpen((prev) => !prev);
  // };

  // const closeDropdown = () => {
  //   setIsDropdownOpen(false);
  // };

  const fetchData = async () => {
    try {
      const response = await axios.post(apiCall + "generalsettings/getall");
      setData(response.data[0]);
      // console.log(response.data[0]);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    // Helper functions
    const getWindowWidth = () => window.innerWidth;
    const getWindowHeight = () => window.innerHeight;
    const getHeaderHeight = () =>
      document.querySelector("header")?.offsetHeight || 0;

    const handleShowCollapse = () => {
      const navbarClone = navbarCloneRef.current;
      if (!navbarClone) return;

      const body = document.body;
      const html = document.documentElement;

      if (!body.classList.contains("navbar-collapse-show")) {
        body.classList.add("navbar-collapse-show");
        html.classList.add("overflow-hidden");

        // Check for custom mobile nav background color
        const mobileNavBgColor = body.getAttribute("data-mobile-nav-bg-color");
        if (mobileNavBgColor) {
          document
            .querySelector(".navbar-show-modern-bg")
            ?.style.setProperty("background", mobileNavBgColor);
          document
            .querySelector(".navbar-full-screen-menu-inner")
            ?.style.setProperty("background", mobileNavBgColor);
        }

        if (getWindowWidth() <= 768) {
          const windowHeight = getWindowHeight();
          const headerHeight = getHeaderHeight();
          navbarClone.style.maxHeight = `${windowHeight - headerHeight}px`;
        }
      }
    };

    const handleHideCollapse = () => {
      // console.log("Navbar is hidden");
      const body = document.body;
      const html = document.documentElement;

      if (body.classList.contains("navbar-collapse-show")) {
        body.classList.remove("navbar-collapse-show");
        html.classList.remove("overflow-hidden");
      }
    };

    const navbar = document.querySelector(".navbar-collapse.collapse");
    if (navbar) {
      navbar.addEventListener("show.bs.collapse", handleShowCollapse);
      navbar.addEventListener("hide.bs.collapse", handleHideCollapse);
    }

    return () => {
      if (navbar) {
        navbar.removeEventListener("show.bs.collapse", handleShowCollapse);
        navbar.removeEventListener("hide.bs.collapse", handleHideCollapse);
      }
    };
  }, []);

  const handleLinkClick = () => {
    const body = document.body;
    const html = document.documentElement;

    // Remove classes when a link is clicked
    body.classList.remove("navbar-collapse-show");
    html.classList.remove("overflow-hidden");
    setMenuVisible(false); // Update the state
  };

  useEffect(() => {
    if (typeof setTopSpaceHeight === "function") {
      setTopSpaceHeight();
    }
  }, []);

  const formatPhoneNumber = (number) => {
    if (!number) return ""; // Handle null/undefined values
    return number.replace(/(\d{4})(\d{6})/, "$1 $2");
  };

  const formatLandline = (number) => {
    if (!number) return ""; // Handle null/undefined values
    return number.replace(/(\d{3})(\d{7})/, "$1 $2");
  };

  useEffect(() => {
    // Delay image display by 1 second
    const timer = setTimeout(() => {
      setShowImage(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50 && !hasScrolled) {
        setMarginTop(0);
        setHasScrolled(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [hasScrolled]);

  return (
    <>
      <header className="header-with-topbar">
        <div className="header-top-bar top-bar-light header-bg-sg-gradient">
          <div className="container">
            <div className="row align-items-center m-0 py-2">
              <div className="col justify-content-between gap-4 md-p-0">
                {/* Social Media Icons */}
                <div className="header-icon">
                  <div className="header-social-icon icon">
                    {settingdata?.sociallinks?.facebook && (
                      <a
                        href={settingdata?.sociallinks?.facebook}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="fa-brands fa-facebook-f"></i>
                      </a>
                    )}
                    {settingdata?.sociallinks?.instagram && (
                      <a
                        href={settingdata?.sociallinks?.instagram}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="fa-brands fa-instagram"></i>
                      </a>
                    )}
                    {settingdata?.sociallinks?.twitter && (
                      <a
                        href={settingdata?.sociallinks?.twitter}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="fa-brands fa-x-twitter"></i>
                      </a>
                    )}
                    {settingdata?.sociallinks?.youtube && (
                      <a
                        href={settingdata?.sociallinks?.youtube}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="fa-brands fa-youtube"></i>
                      </a>
                    )}
                  </div>
                </div>
              </div>

              <div className="col justify-content-end header-icon md-p-0">
                <div className="header-social-icon icon">
                  <a
                    href={`tel:${settingdata?.ambulance}`}
                    className="widget fs-14 lh-1 fw-600"
                  >
                    <i className="fa-solid fa-truck-medical"></i>
                    <span className="text-capitalize">ambulance:</span>+91{" "}
                    {formatPhoneNumber(settingdata?.ambulance)}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Navigation Bar */}
        <nav
          className="navbar navbar-expand-lg header-light bg-white responsive-sticky flex-column"
          data-header-hover="light"
          ref={navbarCloneRef}
          // style={{ marginTop: "-10px" }}
        >
          {(location.pathname !== "/" || showImage) && (
            <img
              src={tagline}
              alt="gokulam-tagline"
              className="mobile-tagline d-block d-md-none"
            />
          )}
          <div className="container md-p-0 justify-content-between position-relative">
            <div
              className="position-absolute overflow-hidden z-n1"
              style={{ inset: 0 }}
            >
              {/* Animated Logos */}
              <img
                src={gokulam_logo_icon}
                alt="gokulam logo"
                className="animated-logo-header slide"
              />
              <img
                src={gokulam_logo_icon}
                alt="gokulam logo"
                className="animated-logo-header rotate d-none d-lg-inline"
              />
            </div>

            {/* Logo Section */}
            <div className="col-auto me-lg-0 me-auto">
              <Link className="navbar-brand" to="/">
                {settingdata?.logo ? (
                  <div>
                    <img
                      src={`${mediaUrl}/${settingdata?.logo}`}
                      alt="Gokulam Logo"
                      className="default-logo"
                    />
                    <img
                      src={`${mediaUrl}/${settingdata?.logo}`}
                      alt="Gokulam Logo"
                      className="alt-logo"
                    />
                    <img
                      src={`${mediaUrl}/${settingdata?.logo}`}
                      alt="Gokulam Logo"
                      className="mobile-logo"
                    />
                  </div>
                ) : (
                  <>
                    <img
                      src={gokulam_superspeciality_logo}
                      alt="Gokulam Logo"
                      className="default-logo"
                    />
                    <img
                      src={gokulam_superspeciality_logo}
                      alt="Gokulam Logo"
                      className="alt-logo"
                    />
                    <img
                      src={gokulam_superspeciality_logo}
                      alt="Gokulam Logo"
                      className="mobile-logo"
                    />
                  </>
                )}
              </Link>
            </div>

            {/* Tagline Section */}
            <div className="col-4 align-items-center justify-content-center d-none d-md-flex">
              <img src={tagline} alt="Gokulam Tagline" width="300" />
            </div>

            {/* Contact us Dropdown */}
            <div className="col-auto text-end lg-pe-5px d-none d-lg-flex">
              <ul className="navbar-nav">
                <li
                  className={`nav-item dropdown simple-dropdown ${
                    openDropdown === "emergency-contact" ? "open" : ""
                  }`}
                  onMouseEnter={() => setOpenDropdown("emergency-contact")}
                  onMouseLeave={() => setOpenDropdown(null)}
                >
                  {/* Emergency Contact Icon */}
                  <img
                    src={emergencyContact}
                    alt="Emergency Contact"
                    width="40px"
                  />

                  {/* Contact Us Link */}
                  <a
                    href="#"
                    className="lh-base fs-18 -nav-link mx-2 fw-600 text-red"
                    style={{ textDecoration: "none" }}
                    onClick={(e) => e.preventDefault()} // Prevent default anchor behavior
                  >
                    Contact us
                  </a>

                  {/* Dropdown Icon */}
                  <i
                    className={`fa-solid fa-angle-down dropdown-toggle ${
                      isDropdownOpen ? "show" : ""
                    }`}
                    id="navbarDropdownMenuLink6"
                    role="button"
                    aria-expanded={isDropdownOpen}
                  ></i>

                  {/* Dropdown Menu - Conditional Rendering */}
                  {openDropdown === "emergency-contact" && (
                    <ul
                      className="dropdown-menu pt-30px pb-30px"
                      aria-labelledby="navbarDropdownMenuLink6"
                      style={{ display: "block" }}
                    >
                      <li>
                        <div className="d-flex align-items-center gap-2">
                          <div className="d-flex align-items-center justify-content-center bg-base-color w-35px h-35px rounded-pill">
                            <i className="bi bi-telephone text-white"></i>
                          </div>
                          <div className="d-flex flex-column text-start">
                            <div className="lh-base fs-16">
                              <a
                                href={`tel:${settingdata?.landline}`}
                                className="text-base-color fw-bold p-0"
                              >
                                +91 {formatLandline(settingdata?.landline)}
                              </a>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li className="mt-15px">
                        <div className="d-flex align-items-center gap-2">
                          <div className="d-flex align-items-center justify-content-center bg-base-color w-35px h-35px rounded-pill">
                            <i className="bi bi-whatsapp text-white"></i>
                          </div>
                          <div className="d-flex flex-column text-start">
                            <span className="lh-1 fs-13 fw-400">WhatsApp</span>
                            <div className="lh-base fs-16">
                              <a
                                href={`tel:${settingdata?.contactno}`}
                                className="text-base-color fw-bold p-0"
                              >
                                +91 {settingdata?.contactno}
                              </a>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  )}
                </li>
              </ul>
            </div>

            {/* Navbar Toggle for Mobile */}
            <div className="col-auto d-lg-none" style={{ display: "flex" }}>
              <button
                className="navbar-toggler float-start"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded={isMenuVisible ? "true" : "false"}
                aria-label="Toggle navigation"
                onClick={() => handleMenuToggle("down")}
                style={{ width: "50px", height: "50px", position: "relative" }}
              >
                <span
                  className="navbar-toggler-line"
                  style={{
                    background: "var(--dark-gray)",
                    height: "2px",
                    width: isMenuVisible ? "0%" : "14px",
                    display: "block",
                    borderRadius: "0",
                    position: "absolute",
                    left: "0",
                    right: "0",
                    margin: "auto",
                    transition: "0.25s",
                    top: "12px",
                  }}
                ></span>
                <span
                  className="navbar-toggler-line"
                  style={{
                    background: "var(--dark-gray)",
                    height: "2px",
                    width: "22px",
                    display: "block",
                    borderRadius: "0",
                    position: "absolute",
                    left: "0",
                    right: "0",
                    margin: "auto",
                    transition: "0.25s",
                    top: "18px",
                    transform: isMenuVisible ? "rotate(45deg)" : "rotate(0)",
                  }}
                ></span>
                <span
                  className="navbar-toggler-line"
                  style={{
                    background: "var(--dark-gray)",
                    height: "2px",
                    width: "22px",
                    display: "block",
                    borderRadius: "0",
                    position: "absolute",
                    left: "0",
                    right: "0",
                    margin: "auto",
                    transition: "0.25s",
                    top: "18px",
                    transform: isMenuVisible ? "rotate(-45deg)" : "rotate(0)",
                  }}
                ></span>
                <span
                  className="navbar-toggler-line"
                  style={{
                    background: "var(--dark-gray)",
                    height: "2px",
                    width: isMenuVisible ? "0%" : "14px",
                    display: "block",
                    borderRadius: "0",
                    position: "absolute",
                    left: "0",
                    right: "0",
                    margin: "auto",
                    transition: "0.25s",
                    top: "24px",
                  }}
                ></span>
              </button>
            </div>
          </div>

          {/* Bottom Menu */}
          <div className="bottom_menu w-100 border-top">
            <div className="container">
              <div className="col-auto menu-order position-static">
                <div
                  className={`collapse navbar-collapse justify-content-between`}
                  id="navbarNav"
                >
                  <ul className="navbar-nav">
                    <li className="nav-item">
                      <NavLink
                        to="/"
                        className={({ isActive }) =>
                          `nav-link ${isActive ? "active" : ""}`
                        }
                        title="Home"
                        exact="true"
                      >
                        <i className="fa-solid fa-house"></i>
                      </NavLink>
                    </li>

                    <li className="divider-lg"></li>

                    <li
                      className={`nav-item dropdown simple-dropdown ${
                        openDropdown === "about" ? "open" : ""
                      }`}
                      onMouseEnter={() => setOpenDropdown("about")}
                      onMouseLeave={() => setOpenDropdown(null)}
                    >
                      <a href="#" className="nav-link" title="About us">
                        About Us&nbsp;
                        <i
                          className="fa-solid fa-angle-down dropdown-toggle"
                          role="button"
                        ></i>
                      </a>

                      {openDropdown === "about" && (
                        <ul className="dropdown-menu">
                          <li className="dropdown">
                            <Link to={"/our-health-care"}>Our Health Care</Link>
                          </li>
                          <li className="dropdown">
                            <Link to={"/message-from-chairman"}>
                              Message from Chairman
                            </Link>
                          </li>
                          <li className="dropdown">
                            <Link to={"/message-from-director"}>
                              Message from Director
                            </Link>
                          </li>
                          <li className="dropdown">
                            <Link to={"/leadership-team"}>Leadership Team</Link>
                          </li>
                        </ul>
                      )}
                    </li>

                    <li className="divider-lg"></li>

                    <li
                      className={`nav-item dropdown submenu ${
                        openDropdown === "departments" ? "open" : ""
                      }`}
                      onMouseEnter={() => setOpenDropdown("departments")}
                      onMouseLeave={() => setOpenDropdown(null)}
                    >
                      <a href="#" className="nav-link" title="Departments">
                        Departments&nbsp;
                        <i
                          className="fa-solid fa-angle-down dropdown-toggle"
                          role="button"
                        ></i>
                      </a>

                      {openDropdown === "departments" && (
                        <div className="dropdown-menu submenu-content">
                          <div className="container">
                            <div className="row">
                              <div className="col-12 col-lg-8">
                                <div
                                  className="departments_menu"
                                  style={{ width: "100%" }}
                                >
                                  {department.map((dept, index) => (
                                    <Link
                                      to={`/department/${dept.slug}`}
                                      key={index}
                                      state={{ departmentId: dept.id }}
                                      className="department-link"
                                    >
                                      <img
                                        src={`${mediaUrl}/${dept?.icon}`}
                                        alt={dept.name}
                                        width="30px"
                                      />
                                      <span className="ms-15px">
                                        {dept.name}
                                      </span>
                                    </Link>
                                  ))}
                                </div>
                              </div>

                              <div className="col-md-4 d-none d-lg-block">
                                <div className="position-relative h-100 w-100">
                                  <picture>
                                    <source
                                      media="(max-width: 767px)"
                                      srcSet={emergencyBg}
                                    />
                                    <source
                                      media="(min-width: 991px)"
                                      srcSet={emergencyBg}
                                    />
                                    <img
                                      src={emergencyBg}
                                      className="img-fluid"
                                      alt=""
                                    />
                                  </picture>
                                  <div className="book_appointment_section_mega_menu">
                                    <div className="d-flex gap-1">
                                      <img
                                        src={emergency24x7}
                                        width="40px"
                                        alt="Emergency"
                                      />
                                      <h5 className="fs-20 fw-600 mb-2 text-dark">
                                        Emergency Care
                                      </h5>
                                    </div>
                                    <p className="fs-16 lh-md">
                                      Lorem ipsum dolor sit amet consectetur
                                      adipisicing elit Nihil assumenda suscipit
                                    </p>
                                    <a
                                      href="#"
                                      className="btn btn-medium text-white btn-rounded rounded-pill btn-gradient-sg-header d-table d-lg-inline-block"
                                    >
                                      Call now
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </li>

                    <li className="divider-lg"></li>

                    <li className="nav-item">
                      <Link
                        to={"/facilities"}
                        className="nav-link"
                        title="Facilities"
                      >
                        Facilities
                      </Link>
                    </li>

                    <li className="divider-lg"></li>

                    <li className="nav-item">
                      <Link
                        to={"/international-patients"}
                        className="nav-link"
                        title="International Patients"
                      >
                        International Patients
                      </Link>
                    </li>

                    <li className="divider-lg"></li>

                    <li className="nav-item">
                      <Link
                        to={"/patient-portal"}
                        className="nav-link"
                        title="Patient Portal"
                      >
                        Patient Portal
                      </Link>
                    </li>

                    <li className="divider-lg"></li>

                    <li className="nav-item">
                      <Link
                        to={"/news-and-events"}
                        className="nav-link"
                        title="News & Events"
                      >
                        News & Events
                      </Link>
                    </li>
                  </ul>

                  {/* Email (Desktop View) */}
                  <div className="align-items-center gap-2 d-none d-lg-flex">
                    <img src={mailIcon} alt="Email Icon" width="40px" />
                    <div className="d-flex flex-column text-start">
                      <span className="lh-1 fs-13">Email</span>
                      <div className="lh-base fs-16">
                        <Link
                          to={`mailto:${settingdata?.mail}`}
                          className="text-base-color fw-600"
                          onClick={(e) => {
                            e.preventDefault(); // Prevent React Router navigation
                            window.location.href = `mailto:${settingdata?.mail}`;
                          }}
                        >
                          {settingdata?.mail}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>

        {/* Mobile Menu  */}
        {isMenuVisible && (
          <animated.div
            style={{ ...props, display: isMenuVisible ? "block" : "none" }}
            className="navbar-full-screen-menu-inner"
          >
            <div
              className="collapse navbar-collapse justify-content-between navbar-collapse-clone "
              id="navbarNav-clone"
              style={{ maxHeight: "100vh" }}
            >
              <div
                id="mCSB_1"
                className="mCustomScrollBox mCS-light mCSB_vertical mCSB_inside"
                style={{ maxHeight: "100vh" }}
                tabIndex="0"
              >
                <PerfectScrollbar
                  options={{ suppressScrollX: true }}
                  style={{
                    maxHeight: "100vh",
                    zIndex: 100,
                  }}
                >
                  <div
                    id="mCSB_1_container"
                    className="mCSB_container"
                    style={{ position: "relative", top: "0", left: "0" }}
                    dir="ltr"
                  >
                    <ul className="navbar-nav">
                      <li className="nav-item">
                        <Link
                          to="/"
                          className="nav-link"
                          title="Home"
                          onClick={handleLinkClick}
                        >
                          <i className="fa-solid fa-house"></i>
                        </Link>
                      </li>

                      <li className="nav-item dropdown submenu">
                        <a href="#" className="nav-link" title="About Us">
                          About Us&nbsp;
                        </a>
                        <i
                          className="fa-solid fa-angle-down dropdown-toggle dropdown-toggle-clone"
                          id="navbarDropdownMenuLinkAboutUs"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        ></i>

                        <ul
                          className="dropdown-menu submenu-content"
                          aria-labelledby="navbarDropdownMenuLinkAboutUs"
                        >
                          <li className="dropdown">
                            <Link to={"/"}>Our Health Care</Link>
                          </li>
                          <li className="dropdown">
                            <Link to={"/"}>Message from Chairman</Link>
                          </li>
                          <li className="dropdown">
                            <Link to={"/"}>Message from Director</Link>
                          </li>
                          <li className="dropdown">
                            <Link to={"/"}>Leadership Team</Link>
                          </li>
                        </ul>
                      </li>

                      <li className="nav-item dropdown submenu">
                        <a
                          href="#"
                          className={`nav-link ${
                            isDepartmentActive ? "active" : ""
                          }`}
                          title="Departments"
                        >
                          Departments
                        </a>
                        <i
                          className="fa-solid fa-angle-down dropdown-toggle dropdown-toggle-clone"
                          id="navbarDropdownMenuLink7"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        ></i>
                        <div
                          className="dropdown-menu submenu-content"
                          aria-labelledby="navbarDropdownMenuLink7"
                        >
                          <div className="container">
                            <div className="row">
                              <div className="col-12 col-lg-8 p-0">
                                <div className="departments_menu">
                                  {department.map((dept, index) => (
                                    <Link
                                      to={`/department/${dept.slug}`}
                                      key={dept.slug}
                                      state={{ departmentId: dept.id }} // Passing dept.id as state
                                      className="department-link"
                                      onClick={(e) => {
                                        // console.log("Clicked Department Slug:", dept.slug);
                                        toggledropdown(); // Keep this if needed
                                        setMenuVisible(false);
                                        handleLinkClick();
                                      }}
                                    >
                                      <img
                                        src={`${mediaUrl}/${dept?.icon}`}
                                        alt={dept.name}
                                        width="30px"
                                      />
                                      <span>{dept.name}</span>
                                    </Link>
                                  ))}
                                </div>
                              </div>
                              <div className="col-md-4 d-none d-lg-block">
                                <div className="position-relative h-100 w-100">
                                  <picture>
                                    <source
                                      media="(max-width: 767px)"
                                      srcset={emergencyBg}
                                    />
                                    <source
                                      media="(min-width: 991px)"
                                      srcset={emergencyBg}
                                    />
                                    <img
                                      src={emergencyBg}
                                      className="img-fluid mCS_img_loaded"
                                      alt=""
                                      data-no-retina=""
                                    />
                                  </picture>
                                  <div className="book_appointment_section_mega_menu">
                                    <div className="d-flex gap-1">
                                      <img
                                        src={emergency24x7}
                                        width="40px"
                                        alt=""
                                        className="mCS_img_loaded"
                                        data-no-retina=""
                                      />
                                      <h5 className="fs-20 fw-600 mb-2 text-dark">
                                        Emergency Care
                                      </h5>
                                    </div>
                                    <p className="fs-16 lh-md">
                                      Lorem ipsum dolor sit amet consectetur
                                      adipisicing elit Nihil assumenda suscipit
                                    </p>
                                    <a
                                      href="#"
                                      className="btn btn-medium text-white btn-rounded rounded-pill btn-gradient-sg-header d-table d-lg-inline-block"
                                    >
                                      Call now
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>

                      <li className="nav-item">
                        <a href="#" className="nav-link" title="Facilities">
                          Facilities
                        </a>
                      </li>

                      <li className="nav-item">
                        <a
                          href="#"
                          className="nav-link"
                          title="International Patients"
                        >
                          International Patients
                        </a>
                      </li>

                      <li className="nav-item">
                        <a href="#" className="nav-link" title="Patient Portal">
                          Patient Portal
                        </a>
                      </li>

                      <li className="nav-item">
                        <a href="#" className="nav-link" title="News & Events">
                          News & Events
                        </a>
                      </li>

                      {/* Contact Details (Mobile View) */}
                      <li className="nav-item d-lg-none">
                        <div className="d-flex gap-4 flex-wrap">
                          <div className="d-flex align-items-center gap-2">
                            <div className="d-flex align-items-center justify-content-center bg-base-color w-35px h-35px rounded-pill">
                              <i className="bi bi-telephone text-white"></i>
                            </div>
                            <div className="d-flex flex-column text-start">
                              <span className="lh-1 fs-13 fw-400">
                                Contact us
                              </span>
                              <div className="lh-base fs-16">
                                <a
                                  href={`tel:${data?.landline}`}
                                  className="text-base-color fw-bold p-0"
                                >
                                  +91 {formatLandline(data?.landline)}
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className="d-flex align-items-center gap-2">
                            <div className="d-flex align-items-center justify-content-center bg-base-color w-35px h-35px rounded-pill">
                              <i className="bi bi-whatsapp text-white"></i>
                            </div>
                            <div className="d-flex flex-column text-start">
                              <span className="lh-1 fs-13 fw-400">
                                WhatsApp
                              </span>
                              <div className="lh-base fs-16">
                                <a
                                  href={`tel:${data?.contactno}`}
                                  className="text-base-color fw-bold p-0"
                                >
                                  +91 {data?.contactno}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>

                      {/* Email (Mobile View) */}
                      <li className="nav-item d-lg-none mt-10px">
                        <div className="d-flex align-items-center gap-2">
                          <img src={mailIcon} alt="Email Icon" width="40px" />
                          <div className="d-flex flex-column text-start">
                            <span className="lh-1 fs-13">Email</span>
                            <div className="lh-base fs-16">
                              <Link
                                to={`mailto:${data.mail}`}
                                className="text-base-color fw-600"
                                onClick={(e) => {
                                  e.preventDefault(); // Prevent React Router navigation
                                  window.location.href = `mailto:${data.mail}`;
                                }}
                              >
                                {data.mail}
                              </Link>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>

                    <div className="align-items-center gap-2 d-none d-lg-flex">
                      <img
                        src={mailIcon}
                        alt=""
                        width="40px"
                        className="mCS_img_loaded"
                        data-no-retina=""
                      />
                      <div className="d-flex flex-column text-start">
                        <span className="lh-1 fs-13">Email</span>
                        <div className="lh-base fs-16">
                          <Link
                            to={`mailto:${data.mail}`}
                            className="text-base-color fw-600"
                            onClick={(e) => {
                              e.preventDefault(); // Prevent React Router navigation
                              window.location.href = `mailto:${data.mail}`;
                            }}
                          >
                            {data.mail}
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </PerfectScrollbar>
              </div>
            </div>
            <button
              className="navbar-toggler float-start navbar-toggler-clone"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="#navbarNav-clone"
              aria-expanded="true"
              aria-label="Toggle navigation"
              data-target="#navbarNav-clone"
              onClick={() => handleMenuCloneToggle("up")}
              style={{ padding: "0 15px" }}
            >
              <span
                className="navbar-toggler-line"
                // style={{ top: "7px", width: "0%" }}
              ></span>
              <span
                className="navbar-toggler-line"
                // style={{ transform: "rotate(45deg)" }}
              ></span>
              <span
                className="navbar-toggler-line"
                // style={{ transform: "rotate(-45deg)" }}
              ></span>
              <span
                className="navbar-toggler-line"
                // style={{ top: "7px", width: "0%" }}
              ></span>
            </button>
          </animated.div>
        )}
        {/* Floating Buttons */}
        <div className="floating_btns_section">
          <style>
            {`
              @keyframes shadow-pulse {
                0% {
                  box-shadow: 0 0 0 0px rgba(236, 25, 21, 0.4);
                }
                100% {
                  box-shadow: 0 0 7px 25px rgba(0, 112, 244, 0);
                }
              }

              .pulse {
                text-align: center;
                border-radius: 50px;
                animation: shadow-pulse 1.5s infinite;
              }
            `}
          </style>

          <div className="floating_btn">
            <div className="floating_btn_content">
              <span> Search </span>
            </div>
            <button
              onClick={() => setModalIsOpen(true)}
              className="floating_btn_icon popup-with-move-anim"
              style={{ border: "none" }}
            >
              <i className="bi bi-search"></i>
            </button>
            <Modal
              isOpen={modalIsOpen}
              onRequestClose={() => setModalIsOpen(false)}
              className="modal-popup"
              overlayClassName="modal-overlay"
              ariaHideApp={false}
            >
              <div>
                <button
                  onClick={() => setModalIsOpen(false)}
                  className="close-btn"
                >
                  <span style={{ textAlign: "center", fontSize: "30px" }}>
                    &times;
                  </span>
                </button>
                <div className="popup_search_box" style={{ padding: "20px" }}>
                  <form className="position-relative">
                    <input
                      className="form-control"
                      type="email"
                      name="email"
                      placeholder="Search for Doctor, Hospital or Treatment"
                    />
                    <button
                      className="btn bg-base-color search_submit_btn"
                      aria-label="submit"
                    >
                      <i className="fa-solid fa-magnifying-glass text-white m-0"></i>
                    </button>
                  </form>
                  <div className="form-results border d-none"></div>
                </div>
              </div>
            </Modal>
          </div>

          <div className="floating_btn">
            <div className="floating_btn_content">
              <span>Happy to help</span>
            </div>
            <Link to={"https://wa.me/919947007970"} className="floating_btn_icon pulse" target="_blank">
              <i className="fa-solid fa-user-doctor"></i>
            </Link>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
